import React from 'react';
import useTranslatedOptions from '@ubeya/shared/hooks/useTranslatedOptions';
import { ContextMenu } from '@ubeya/shared-web/components';

const ActionsRenderer = ({ rowData, columnData: { onEdit, onDelete } }) => {
  const options = useTranslatedOptions([
    { label: 'edit', onClick: () => onEdit(rowData) },
    { label: 'delete', onClick: () => onDelete(rowData) }
  ]);

  return <ContextMenu options={options} usePortal />;
};

export default ActionsRenderer;
